import rmskincareAPI from '../utils/rmskincareAPI'

const appointmentApi = {
  getAppointment: async (date, endTime = null) => {
    let requestBody = {
      currentTime: date,
    }
    
    // 如果提供了endTime，则添加到请求体中
    if (endTime) {
      requestBody.endTime = endTime
    }
    
    let result = await rmskincareAPI.post('management/appointment/between', requestBody)
    return result.data
  },
  createAppointment: async (data, employeeId) => {
    // console.log("createAppointment",data)
    let result = await rmskincareAPI.post(
      `management/appointment?employeeId=${employeeId}`,
      data
    )
    // console.log(result)
    return result.data
  },

  modifyAppointment: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/modify',
      data
    )
    return result.data
  },

  deleteAppointment: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/delete/${id}`
    )
    // console.log(result)
    return result.data
  },

  cancelAppointment: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/cancel?id=${id}`
    )
    // console.log(result)
    return result.data
  },

  findAppointmentById: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/findone/${id}`
    )
    // console.log(result.data);
    return result.data
  },

  getRoster: async (isNext) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/getRoster/${isNext}`
    )
    // console.log(result.data)
    return result.data
  },

  findAppointmentByCondition: async (data) => {
    // console.log(data)
    let result = await rmskincareAPI.post(
      '/management/appointment/findAppointment/',
      data
    )
    // console.log(result.data)
    return result.data
  },
  exchangeAppointment: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/exchangeAppointment/',
      data
    )
    return null
  },
  getAppointmentByEmployee: async (data) => {
    let result = await rmskincareAPI.post(
      '/management/appointment/getAppointmentByEmployee',
      data
    )
    return result.data.data
  },

  /* Room */
  getRoomList: async () => {
    const status = 1
    let result = await rmskincareAPI.get(`/room/list?status=${status}`)
    return result.data.data
  },

  saveRoom: async (requestBody) => {
    let result = await rmskincareAPI.post('/room/save', requestBody)
    return result.data
  },

  updateMessage: async () => {
    let result = await rmskincareAPI.get('/management/appointment/sendMsg')
    // console.log('api result', result)
    return result.data
  },

  getAppointmentListByDate : async (currentDate) => {
    let result = await rmskincareAPI.get(`/management/appointment/rm/findByDate?currentDate=${currentDate}`)
    //  console.log('appointmentListByDate api result', result)
    return result.data.data
  },

  // 标记官网预约为已联系（旧接口，保留兼容）
  markWebsiteAppointmentContacted: async (id, contacted, note = '') => {
    let result = await rmskincareAPI.post(
      `/management/appointment/markContacted/${id}`,
      { contacted, contactNote: note }
    )
    return result.data
  },

  // 更新官网预约处理状态
  // status: 'CONTACTED' | 'NEED_FOLLOW' | 'COMPLETED'
  // payload for COMPLETED must include: { beauticianId, confirmedStart, confirmedEnd }
  updateWebsiteAppointmentStatus: async (id, status, payload = {}) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/website/updateStatus/${id}`,
      { status, ...payload }
    )
    return result.data
  },

  // 记录账户打开官网预约的行为
  logWebsiteAppointmentView: async (id) => {
    let result = await rmskincareAPI.post(
      `/management/appointment/website/logView/${id}`
    )
    return result.data
  },

  // 获取官网预约的操作日志
  getWebsiteAppointmentLogs: async (id) => {
    let result = await rmskincareAPI.get(
      `/management/appointment/website/logs/${id}`
    )
    return result.data.data
  },

  // 检查员工在指定时间段是否有预约冲突（按上午/下午时间段检查，跨门店）
  checkEmployeePeriodConflict: async (employeeId, startTime, endTime, currentStoreId, appointmentId = null) => {
    let requestBody = {
      employeeId: employeeId,
      startTime: startTime,
      endTime: endTime,
      currentStoreId: currentStoreId, // 当前预约的门店ID
      appointmentId: appointmentId // 编辑时排除当前预约
    }
    let result = await rmskincareAPI.post(
      '/management/appointment/checkPeriodConflict',
      requestBody
    )
    return result.data
  },
}

export default appointmentApi
